import { StyleSheet, Platform, type DimensionValue } from 'react-native';

const C = {
  bg: '#0A0614',
  cardBg: '#1A1233',
  border: '#2A1F44',
  expandBorder: 'rgba(167,139,250,0.08)',
  expandBg: 'rgba(167,139,250,0.04)',
  primary: '#A78BFA',
  textDefault: '#F7FAFC',
  textDim: '#9CA3AF',
  textMuted: '#6B7280',
  textDark: '#111827',
} as const;

export function getAcceptChallengePicksModalStyles() {
  return StyleSheet.create({
    sheetContainer: {
      backgroundColor: C.bg,
      borderTopLeftRadius: 20,
      borderTopRightRadius: 20,
      width: '100%',
      height: '92%',
      maxHeight: '92%',
      ...(Platform.OS === 'web' && {
        height: '92vh' as DimensionValue,
        maxHeight: '92vh' as DimensionValue,
      }),
    },
    sheetContent: {
      flex: 1,
    },
    header: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingHorizontal: 20,
      paddingTop: 16,
      paddingBottom: 16,
      borderBottomWidth: 1,
      borderBottomColor: C.border,
    },
    title: {
      fontSize: 18,
      fontWeight: '700' as const,
      color: C.textDefault,
      letterSpacing: 0.2,
    },
    closeButton: {
      padding: 8,
      margin: -8,
    },
    closeButtonPressed: { opacity: 0.7 },
    closeButtonHover: { opacity: 0.9 },
    loadingContainer: {
      padding: 48,
      alignItems: 'center',
      flex: 1,
      justifyContent: 'center',
    },
    scrollContent: {
      paddingHorizontal: 12,
      paddingTop: 12,
      paddingBottom: 32,
      gap: 10,
    },
    matchCard: {
      backgroundColor: C.cardBg,
      borderRadius: 12,
      overflow: 'hidden',
      borderWidth: 1,
      borderColor: C.border,
      ...(Platform.OS === 'web'
        ? { boxShadow: '0 2px 4px rgba(0,0,0,0.4)' as const }
        : {
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 2 },
            shadowOpacity: 0.4,
            shadowRadius: 4,
            elevation: 3,
          }),
    },
    /** Sport marker in the match header (specs/multi-sport-challenges). */
  sportIconWrap: {
    marginRight: 8,
    alignSelf: 'center',
  },
  matchHeader: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: 12,
      paddingVertical: 10,
      gap: 10,
    },
    teamsColumn: {
      flex: 1,
      gap: 4,
      minWidth: 0,
    },
    teamRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
    },
    teamName: {
      fontSize: 12,
      fontWeight: '600' as const,
      color: C.textDefault,
      flex: 1,
    },
    matchTimeBlock: {
      alignItems: 'flex-end',
      gap: 1,
    },
    matchTime: {
      fontSize: 11,
      color: C.textDim,
      fontVariant: ['tabular-nums'],
    },
    matchDate: {
      fontSize: 10,
      color: C.textMuted,
      fontVariant: ['tabular-nums'],
    },
    marketArea: {
      borderTopWidth: 1,
      borderTopColor: C.expandBorder,
      backgroundColor: C.expandBg,
      paddingHorizontal: 12,
      paddingVertical: 10,
    },
    startedMessage: {
      paddingVertical: 12,
      paddingHorizontal: 16,
      borderRadius: 10,
      backgroundColor: 'rgba(239,68,68,0.12)',
      fontSize: 14,
      fontWeight: '600' as const,
      color: '#EF4444',
      textAlign: 'center',
    },
    submitButton: {
      marginTop: 20,
      paddingVertical: 16,
      borderRadius: 14,
      backgroundColor: C.primary,
      alignItems: 'center',
      justifyContent: 'center',
      ...(Platform.OS === 'web'
        ? { boxShadow: '0 2px 8px rgba(167,139,250,0.35)' as const }
        : {
            shadowColor: C.primary,
            shadowOffset: { width: 0, height: 2 },
            shadowOpacity: 0.35,
            shadowRadius: 6,
            elevation: 4,
          }),
    },
    submitButtonDisabled: {
      backgroundColor: 'rgba(167,139,250,0.35)',
      ...(Platform.OS !== 'web' && { shadowOpacity: 0, elevation: 0 }),
    },
    submitButtonPressed: { opacity: 0.75 },
    submitButtonHover: { opacity: 0.9 },
    submitButtonText: {
      fontSize: 17,
      fontWeight: '700' as const,
      color: C.textDark,
      letterSpacing: 0.3,
    },
  });
}
